<template>
  <v-layout
    column
    fill-height
    class="mb-3"
  >
    <v-card-title class="mb-0 pb-0" v-if="showButtons">
      <v-btn icon :to="getBackUrl" active-class="">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="can('edit schools')">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
             icon
             v-bind="attrs"
             v-on="on"
             @click="editSchool"
          >
            <v-icon>edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('EDIT') }}</span>
      </v-tooltip>
      <div>
        <v-tooltip bottom v-if="can('delete schools')">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="deleteSchool">
              <v-icon>block</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('DELETE') }}</span>
        </v-tooltip>
      </div>
    </v-card-title>
    <v-card-title class="mt-1 pt-0">
    </v-card-title>
    <v-tabs
      :value="value"
      @change="tabChanged"
      centered
      grow
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab dark href="#school">
          {{ $t('SCHOOL') }}
        </v-tab>
        <v-tab dark href="#code">
          {{ $t('MINISTERIAL_CODE') }}
        </v-tab>
        <v-tab dark href="#location">
          {{ $t('MAIN_BRANCH_LOCATIONS') }}
        </v-tab>
    </v-tabs>
  </v-layout>
</template>
<script>

  export default {
    name: 'SchoolTabs',
    props: {
      zone: Object,
      value: String,
      showButtons: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      getBackUrl() {
        if (this.$route.query.returnUrl) {
          return { path: this.$route.query.returnUrl };
        }
          return { name: this.routeName.SCHOOL };
      },
    },
    methods: {
      deleteSchool() {
        this.$emit('delete');
      },

      editSchool() {
        this.$emit('edit');
      },

      tabChanged(tab) {
        this.$emit('input', tab);
      },

    },
  };
</script>
